import CheckFilled from '@alltrails/denali/icons/CheckCircleFilled';
import styles from './styles/styles.module.scss';

type CompletionIconProps = {
  isCompleted?: boolean;
  isVerified?: boolean;
  onClick?: () => void;
};

const CompletionIcon = ({ isCompleted = false, isVerified = false, onClick }: CompletionIconProps) => {
  if (!isCompleted && !isVerified) {
    return <div />; // Useful for flex placement
  }

  return onClick ? (
    <button className={styles.icon} onClick={onClick} type="button">
      <CheckFilled size="sm" color="--color-brand-onyx" />
    </button>
  ) : (
    <div className={styles.icon}>
      <CheckFilled size="sm" color="--color-brand-onyx" />
    </div>
  );
};

export default CompletionIcon;
